import { useState } from "react";
import { Form } from "react-bootstrap";
import CommonModal from "../modalLayout/CommonModal";
import { useUploadTrackingNumberSheetMutation } from "../../../app/orderApi/OrderApi";
import { showToast } from "../../../helpers/Utils";
import FileUploadBox from "../fileUpload/FileUploadBox";
import Loader from "../loader/Loader";

const UploadeTrackingModal = ({ show, setShow }) => {
  const [file, setFile] = useState(null);
  const [sendEmail, setSendEmail] = useState(false);
  const [uploadTrackingSheet, { isLoading }] = useUploadTrackingNumberSheetMutation();

  const handleConfirm = async () => {
    if (!file) {
      showToast("Please upload a tracking sheet first", "error");
      return;
    }

    const formData = new FormData();
    formData.append("trackingNumberSheet", file);
    formData.append("sendEmail", sendEmail);

    try {
      const response = await uploadTrackingSheet({ formData }).unwrap();
      const data = response?.data;

      const updated = data?.updatedCount || 0;
      const notFoundOrders = data?.notFoundOrdersWithItemID || [];

      if (updated > 0) {
        showToast(
          `Update tracking number and send email: All ${updated} successful!`,
          "success"
        );
      } else {
        showToast(
          "No tracking numbers were updated. Please check the file and try again.",
          "error"
        );
      }

      if (notFoundOrders.length > 0) {
        showToast(`${notFoundOrders.join(", ")} Not found`, "error", {
          duration: Infinity,
        });
      }

      setShow(false);
    } catch (error) {
      console.error("Upload failed:", error);
      if (error.status == 400) {
        showToast(error?.data?.message, "error");
      } else {
        showToast("Failed to upload tracking sheet", "error");
      }
    }
  };

  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title="Upload tracking number sheet"
      centered
      onConfirm={handleConfirm}
      confirmLoading={isLoading}
      cancelDisabled={isLoading}
    >
      {isLoading && <Loader />}
      <FileUploadBox setUploadedFile={setFile} type="xls" tracking />

      <div className="send-email mt-3">
        <Form.Check
          type="switch"
          id="send-email-tracking-switch"
          label="Send email to all customers"
          checked={sendEmail}
          onChange={() => setSendEmail((prev) => !prev)}
        />
      </div>
    </CommonModal>
  );
};

export default UploadeTrackingModal;
